

var $date_in,$date_out;

    $(document).ready(function(){



        var width = parseInt($(this).width());
        var offset = 0;
        if (width < 701) {
            $("#pickadatecss1").attr("href", "/components/pickadate/lib/themes/default.css");
            $("#pickadatecss2").attr("href", "/components/pickadate/lib/themes/default.date.css");
        } else if ((width >= 701)) {
            offset = $('.navbar-default').height();
            $("#pickadatecss1").attr("href", "/components/pickadate/lib/themes/classic.css");
            $("#pickadatecss2").attr("href", "/components/pickadate/lib/themes/classic.date.css");
        }


        $('a.page-scroll').bind('click', function(event) {
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - offset
            }, 1500, 'easeInOutExpo');
            event.preventDefault();
        });




        $("#openDateIn").click(function(e){
            e.stopPropagation();
            e.preventDefault();
            $date_in.pickadate('picker').open();
        });

            //el fem slider
        $('#slider-nuestros-servicios').slick({
            arrows:true
        });

		$('#slider-comentarios').slick({
			arrows:true
		});

        $('.apartments-slider').slick();

        $('.hasTooltip').tooltip();

        //Cookie based popup
        //document.getElementById("myDialog").showModal();

        $("#modal_background").click(function(){
            $("#modal_background").css("display","none");
            $("#myDialog").css("display", "none");
            var html = $('html');
            var scrollPosition = html.data('scroll-position');
            html.css('overflow', html.data('previous-overflow'));
            window.scrollTo(scrollPosition[0], scrollPosition[1])
        });

        $("#onClose").click(function(){
            $("#modal_background").css("display","none");
            $("#myDialog").css("display", "none");
            var html = $('html');
            var scrollPosition = html.data('scroll-position');
            html.css('overflow', html.data('previous-overflow'));
            window.scrollTo(scrollPosition[0], scrollPosition[1])
        });

        var visits = $.cookie('visits') || 0;
        visits++;

        var session = sessionStorage.getItem("popup");

        if ( session == null  && !isMobile()) {

                $("#myDialog").css("display", "block");
                $("#modal_background").css("display", "block");

                var scrollPosition = [
                    self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
                    self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                ];

                sessionStorage.popup = "KO";
        }

		// Photo gallery

        var items = [];
        var index = 0;

        $('.gallery-thumbs figure').each(function() {

            var $this = $(this),
                $link = $this.find('a'),
                $thumb = $this.find('img');

            var item = {
                src:  $link.attr('href'),
                w:    $link.data('width'),
                h:    $link.data('height'),
                msrc: $thumb.attr('src'),
                el:   this
            };

            items.push(item);

            var item_index = index;

            $this.on('click', function() {

                var options = {
                    index:           item_index,
                    history:         false,
                    focus:           false,
                    closeOnScroll:   false,
                    showHideOpacity: true,
                    shareEl:         false,
                    getThumbBoundsFn: function(index) {

                        // find thumbnail element
                        var thumbnail = items[index].el;

                        // get window scroll Y
                        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                        // optionally get horizontal scroll

                        // get position of element relative to viewport
                        var rect = thumbnail.getBoundingClientRect();

                        // w = width
                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width
                        };


                        // Good guide on how to get element coordinates:
                        // http://javascript.info/tutorial/coordinates
                    }
                };

                // Pass data to PhotoSwipe and initialize it
                var gallery = new PhotoSwipe($('.pswp').get(0), PhotoSwipeUI_Default, items, options);
                gallery.init();
            });

            index++;

        });


        if($('.gallery-img').length > 0) {
            responsivePhotoGallery();
            $(window).resize(function () {
                responsivePhotoGallery();
            });
        }

        if($('#comentarios').length > 0 && $('#footer').length > 0 && $('#comentarios').next('#footer').length > 0) {
            $('#comentarios').css({'padding-bottom': '100px'});
        }


        $('#navbar-fuster').find('a.page-scroll').each(function(){
        	if($(this).attr('href') == window.location.href || $(this).attr('href') == window.location.href+'/'){
                $(this).parent('li').addClass('active');
			}
		});





    });



    function responsivePhotoGallery(){
		if($(window).width() < 768 && $('.gallery-thumbs.slick-initialized').length <= 0){
			$('.gallery-thumbs').slick({
				'arrows' : true
			});
		}else if($(window).width() >= 768 &&  $('.gallery-thumbs.slick-initialized').length > 0){
			$('.gallery-thumbs').slick('destroy');
		}
	}

    $(document).mouseup(function(e){
        var container = $('#myDialog');
        if( !container.is(e.target)&& container.has(e.target).length === 0) {
            container.fadeOut();
        }
    });

    function isMobile() {
        if(window.innerWidth <= 800) {
            return true;
        } else {
            return false;
        }
    }

    function scrollTop(){
        $('html, body').stop().animate({
            scrollTop: 0
        }, 1500, 'easeInOutExpo');
    }

    function click_data(data)
	{


		document.getElementById('boto_reserva').style.display='none';

		var data_inicial=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;
		var data_final=document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;


		// si els dos camps estan omplenats, torna a posar al primer i vuida el segon
		if ((data_inicial!='' && data_final!='') || data_inicial=='')
		{
			document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value=data;
			document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value='';
		}
		else
		{
			document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value=data;
		}

		var data_inicial=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;
		var data_final=document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

		// ordena per any mes i dia
		if (data_inicial!='')
		{
			var txt=data_inicial.split('-');
			data_inicial=txt[2]+'-'+txt[1]+'-'+txt[0];
		}
		if (data_final!='')
		{
			var txt=data_final.split('-');
			data_final=txt[2]+'-'+txt[1]+'-'+txt[0];
		}

		// mira si la inicial es superior a la final
		if (data_inicial!='' && data_final!='')
		{
			if (data_inicial > data_final)
			{

				var i=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;
				var f=document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

				document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value=f;
				document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value=i;
			}

			comprova_dates(document.getElementById('FRM_RESERVA_DATA_ENTRADA').value,document.getElementById('FRM_RESERVA_DATA_SORTIDA').value,document.getElementById('FRM_RESERVA_PERSONES').value,document.getElementById('FRM_RESERVA_CODI_IMMOBLE').value,true);

		}

		// actualitza el calendari

		//document.getElementById ('calendari_immoble').src='admin/admin_info/calendari_immoble/calendari.php?PAR_CODI_IMMOBLE='+document.getElementById ('FRM_RESERVA_CODI_IMMOBLE').value+'&PAR_DATA_INICIAL='+document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value+'&PAR_DATA_FINAL='+document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

	}

	function click_data_inicial_reserves()
	{

		var data_inicial=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;

		var txt=data_inicial.split('-');
		var data_final = new Date(parseInt(txt[2]),parseInt(txt[1])-1, parseInt(txt[0])+3, 0, 0, 0);

        $date_out.pickadate('picker').set('select',data_final);

        var data_inicial_formated = new Date(new Date(parseInt(txt[2]),parseInt(txt[1])-1, parseInt(txt[0])));
        $date_out.pickadate('picker').set('max', new Date(data_inicial_formated.addDays(31)));


	}

	function click_data_final_reserves()
	{
		var data_inicial=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;
		var data_final=document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

		if (data_inicial!='' && data_final!='')
		{
			// ordena per any mes i dia
			if (data_inicial!='')
			{
				var txt=data_inicial.split('-');
				data_inicial=txt[2]+'-'+txt[1]+'-'+txt[0];
			}
			if (data_final!='')
			{
				var txt=data_final.split('-');
				data_final=txt[2]+'-'+txt[1]+'-'+txt[0];
			}

			// mira si la inicial es superior a la final

			if (data_inicial > data_final)
			{

				var i=document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value;
				var f=document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

				document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value=f;
				document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value=i;
			}



		}

		// actualitza el calendari

		//document.getElementById ('calendari_immoble').src='admin/admin_info/calendari_immoble/calendari.php?PAR_CODI_IMMOBLE='+document.getElementById ('FRM_RESERVA_CODI_IMMOBLE').value+'&PAR_DATA_INICIAL='+document.getElementById ('FRM_RESERVA_DATA_ENTRADA').value+'&PAR_DATA_FINAL='+document.getElementById ('FRM_RESERVA_DATA_SORTIDA').value;

	}


	function comprova_dates(data_entrada,data_sortida,persones,codi_immoble,mostra_errors)
	{

		if (persones!='' && data_entrada!='' && data_sortida!='' )
		{
			var url='admin/admin_info/reserves/ajax.comprova_dates.php?PAR_DATA_ENTRADA='+data_entrada+'&PAR_DATA_SORTIDA='+data_sortida+'&PAR_CODI_IMMOBLE='+codi_immoble+'&PAR_CODI_RESERVA=';
			var parameters='';

			var AJAX_XML = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseXML;

			//alert ($.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText);

			if (AJAX_XML.getElementsByTagName('ERROR')[0].childNodes[0].data==1)
			{
				if (mostra_errors==true)
				{
					var err_txt=AJAX_XML.getElementsByTagName('TXT_ERRORS_WEB')[0].childNodes[0].data ;
					mostra_dialog('Error',err_txt);
					try
					{
						document.getElementById('boto_reserva').style.display='none';
					}
					catch(e)
					{
					}
				}
				return false;
			}
			else
			{
				if (mostra_errors==true)
				{
					try
					{
						document.getElementById('boto_reserva').style.display='inline';
					}
					catch(e)
					{
					}
				}
				return true;
			}
		}
		else
		{
			try
			{
				document.getElementById('boto_reserva').style.display='none';
			}
			catch(e)
			{
			}
			return false;
		}
	}




	function guarda_dates_reserva()
	{
		var dent;
		var dsort;
		var cimm;
		var persones;


		dent=document.getElementById('FRM_RESERVA_DATA_ENTRADA').value;
		dsort=document.getElementById('FRM_RESERVA_DATA_SORTIDA').value;
		cimm=document.getElementById('FRM_RESERVA_CODI_IMMOBLE').value;
		persones=document.getElementById('FRM_RESERVA_PERSONES').value;

		var url='ajax.guarda_dates_reserva.php?PAR_DATA_ENTRADA='+dent+'&PAR_DATA_SORTIDA='+dsort+'&PAR_CODI_IMMOBLE='+cimm+'&PAR_PERSONES='+persones;;
		var parameters='';
		var AJAX_TEXT = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText;
	}

	function guarda_dates_reserva_1(codi_immoble)
	{
		var dent;
		var dsort;
		var cimm;
		var persones;

		dent=document.getElementById('FRM_RESERVA_DATA_ENTRADA').value;
		dsort=document.getElementById('FRM_RESERVA_DATA_SORTIDA').value;
		persones=document.getElementById('FRM_RESERVA_PERSONES').value;
		cimm=codi_immoble;

		var url='ajax.guarda_dates_reserva.php?PAR_DATA_ENTRADA='+dent+'&PAR_DATA_SORTIDA='+dsort+'&PAR_CODI_IMMOBLE='+cimm+'&PAR_PERSONES='+persones;
		var parameters='';
		var AJAX_TEXT = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText;
	}

	function mostra_preu(id_contenidor)
	{
		var dent;
		var dsort;
		var cimm;
		var pers;


		dent=document.getElementById('FRM_RESERVA_DATA_ENTRADA').value;
		dsort=document.getElementById('FRM_RESERVA_DATA_SORTIDA').value;
		cimm=document.getElementById('FRM_RESERVA_CODI_IMMOBLE').value;
		pers=document.getElementById('FRM_RESERVA_PERSONES').value;



		if (pers!='')
		{

			var url='admin/admin_info/reserves/ajax.calcul_preu.php?PAR_DATA_ENTRADA='+dent+'&PAR_DATA_SORTIDA='+dsort+'&PAR_CODI_IMMOBLE='+cimm+'&PAR_PERSONES='+pers;

			var parameters='';
			var AJAX_XML = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseXML;
			//alert($.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText);

			//document.getElementById('FRM_RESERVA_DETALLS_PREU').value=AJAX_XML.getElementsByTagName('HTML')[0].childNodes[0].data;
			document.getElementById('FRM_RESERVA_IMPORT_PAGAR').value=AJAX_XML.getElementsByTagName('TOTAL_PAGAR')[0].childNodes[0].data;

			document.getElementById(id_contenidor).innerHTML=AJAX_XML.getElementsByTagName('HTML')[0].childNodes[0].data;
			document.getElementById('FRM_RESERVA_DETALLS_PREU').value=escape(AJAX_XML.getElementsByTagName('HTML')[0].childNodes[0].data);
		}
		else
		{
			document.getElementById(id_contenidor).innerHTML='';
		}

	}

	function mostra_preu_total(id_contenidor,data_entrada,data_sortida,persones,codi_immoble)
	{
		var dent;
		var dsort;
		var cimm;
		var pers;


		dent=data_entrada;
		dsort=data_sortida;
		cimm=codi_immoble;
		pers=persones;



		if (pers!='')
		{

			var url='admin/admin_info/reserves/ajax.calcul_preu.php?PAR_DATA_ENTRADA='+dent+'&PAR_DATA_SORTIDA='+dsort+'&PAR_CODI_IMMOBLE='+cimm+'&PAR_PERSONES='+pers;

			var parameters='';
			var AJAX_XML = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseXML;
			//alert($.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText);

			//document.getElementById('FRM_RESERVA_DETALLS_PREU').value=AJAX_XML.getElementsByTagName('HTML')[0].childNodes[0].data;
			document.getElementById(id_contenidor).innerHTML=AJAX_XML.getElementsByTagName('TOTAL')[0].childNodes[0].data;

		}
		else
		{
			document.getElementById(id_contenidor).innerHTML='';
		}

	}

	function urldecode(str)
	{
	   return decodeURIComponent((str+'').replace(/\+/g, '%20'));
	}

	function mostra_dialog(titol,contingut)
	{
		document.getElementById('div_dialog').innerHTML=contingut;

		$(function()
		{
			$("#div_dialog").dialog(
			{
				modal: true,
				resizable: true,
				title: titol,
				height:400,
				width:400,

				buttons:
				{
					Ok: function() {$( this ).dialog( "close" );}
				}
			});
		});
	}


	function selecciona_idioma(idioma)
	{
			var url='ajax.seleccio_idioma.php?PAR_IDIOMA='+idioma;
			var parameters='';
			var AJAX_TXT = $.ajax({url: url, async: false, type: 'GET', data: parameters}).responseText;

			document.location.reload();
	}

    //jQuery to collapse the navbar on scroll
    $(window).scroll(function() {
        if ($(".navbar").offset().top > 50) {
            $(".navbar-fixed-top").addClass("top-nav-collapse");
        } else {
            $(".navbar-fixed-top").removeClass("top-nav-collapse");
        }
    });



    function book() {
        var id       = '{{$item->id}}';
        var date_in  = $('#FRM_RESERVA_DATA_ENTRADA').val();
        var date_out = $('#FRM_RESERVA_DATA_SORTIDA').val();
        var people   = $('#FRM_RESERVA_PERSONES').val();

        $.ajax({
            url: "{{URL::to_action('bookings@check')}}",
            type:  'GET',
            data: {
                ap_id: id,
                date_in : DateFormat.format.date(date_in+' 00:00:00','dd-MM-yyyy'),
                date_out : DateFormat.format.date(date_out+' 00:00:00','dd-MM-yyyy'),
                people: people
            },
            dataType: 'json',
            success: function (data) {
                if (data.code == 200) {
                    window.document.location = '{{URL::to("bookings/checkin/")}}' + id + '/' + date_in + '/' + date_out + '/' + people;
                } else {
                    alert(data.msg);
                }
            }
        });
    }


    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };

